<div class="container bg2 page-sub footer-none">

  <section class="header fixed">

    <article class="header-page">

      <a class="close-btn" backButton></a>

      <div class="page-name-box">응원 하기</div>

    </article>

  </section>


  <section class="setting-page">
    <div class="inner wrap">

      <div class="setting-list">
        <div class="setting-box">
          <div class="setting-tit-box">'듣고 배우는 한국어'에게 용기와 격려를 보내 주시기 바랍니다.</div>
          <br/>
          <div class="setting-des-box">
            보내 주시는 성원에 심심<span class="hanja-size">深深</span>한 감사를 드립니다.<br/>
            회원 정보가 필요 없이, 누구나 이용을 하실 수 있도록 열어 둔 곳이라서
            따로 고마움에 대한 인사 말씀을 드리지 못 할 것입니다.<br/>
            이에, 미리 양해의 말씀을 구합니다.
          </div>
          <div class="pay-btn-box"
               *ngIf="showKakaoPay; else gotoWeb">
            <a class="pay-btn type-kakao" (click)="onClicKakao($event)">
              <i class="ic ic-kakao"></i>
              <div class="txt">카카오페이</div>
            </a>
          </div>
          <ng-template #gotoWeb>
            <div class="goto-web-btn-box">
              <a class="pay-btn type-web" (click)="onClickWeb($event)">
                <div class="txt">
                  {{ dynamicPrefix }}.<br>
                  Listen<br>
                  And<br>
                  Learn<br>
                  Korean.com
                </div>
              </a>
            </div>
          </ng-template>
        </div>
      </div>

    </div>
  </section>

  <!-- <section class="setting-page">
    <div class="inner wrap">

      <div class="setting-list">
        <div class="setting-box">
          <div class="setting-tit-box">카카오톡 간편 송금</div>
          <div class="setting-des-box">
            카카오 간편 송금으로 손쉽게 기부할 수 있습니다.
          </div>
          <div class="setting-btn-box">
            <a class="setting-btn" href="http://kko.to/W1hxYd74T">
              <img src="assets/img/btn_sns_kakao.png" class="sns"/>
              카카오톡으로 송금하기
            </a>
          </div>
        </div>
      </div>

      <div class="setting-list">
        <div class="setting-box">
          <div class="setting-tit-box">페이팔 기부</div>
          <div class="setting-des-box">
            한국에서는 사용할 수 없습니다.
          </div>
          <div class="setting-btn-box">
            <a class="setting-btn" href="https://www.paypal.com/donate/?hosted_button_id=8GBFDUXZ5JRKL">
              <img src="assets/img/paypal.svg" class="paypal"/>
              페이팔로 이동
            </a>
          </div>
        </div>
      </div>

      <div class="setting-list">
        <div class="setting-box">
          <div class="setting-tit-box">기부금 계좌</div>
          <div class="setting-des-box">
            신한 123-45678-0001 홍길동
          </div>
        </div>
      </div>

    </div>

  </section> -->

</div>
